import { useQuery } from "@tanstack/react-query";
import { fetchAllUom } from "../api/fetchAllUom";

export const useAllUom = (body, enabled = true) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["allUom", body],
    queryFn: () => fetchAllUom(body),
    enabled: !!body && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading,
  };
};

